/**
 * Shared UI component for UI Pipeline Strip.
 * PARENT-CHILD CONTRACT: parent screens provide the data and configuration that
 * this wrapper renders or normalizes for reuse across the application.
 */
import { Component, input } from '@angular/core';

import { UiPipelineStage } from './ui-pipeline-strip.types';

/**
 * COMPONENT: Ui Pipeline Strip
 * Inputs: Uses the parameters, injected services, route state, or signal state declared by this file.
 * Output: Returns the documented value or updates component/service state without changing the public contract.
 * Processing: Documents the Angular declaration that connects this class to templates, dependency injection, or template transforms.
 */
@Component({
  selector: 'ui-pipeline-strip',
  standalone: true,
  templateUrl: './ui-pipeline-strip.component.html',
  styleUrl: './ui-pipeline-strip.component.scss'
})
export class UiPipelineStripComponent {
  readonly stages = input<UiPipelineStage[]>([]);
}
